import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class SilentVowelMark extends Mark implements IMark
{
    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void {
        this.markWidth = this.strokeThickness;
        this.markHeight = this.adjustToScale(48);
        if(this.targetTextField)
        {
            const style = this.targetTextField.style;
            const text = this.targetTextField.text;
            //const metrics = TextMetrics.measureText(text, style);

            const fontSize = Number(this.targetTextField.style.fontSize);
            this.parentTarget = this.targetTextField;
            this.targetTextFieldStyle = this.targetTextField.style;
            this.strokeThickness = Number(this.targetTextFieldStyle.fontSize)/20;
            this.markWidth = this.strokeThickness;
            this.markHeight = this.targetTextField.height+(this.adjustToScale(40)*this.multipleOfDefaultFontSize);
            this.markX = this.targetTextField.width/2 + this.markWidth/2;
            this.markY = this.targetTextField.height/2 + (this.adjustToScale(20)*this.multipleOfDefaultFontSize);
            if(this.targetTextField.text == "y")
            {
                this.markHeight = this.targetTextField.height+(this.adjustToScale(70)*this.multipleOfDefaultFontSize);
                this.markY = this.targetTextField.height/2 + (this.adjustToScale(35)*this.multipleOfDefaultFontSize);
            }
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        let mark = new Graphics();
        mark.lineTo(0, this.markHeight);
        mark.stroke({color:color, width:this.strokeThickness, cap:"round"});
        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}